import React from "react";

export const AnimatedLines = ({ variant = "light", className = "" }) => (
  <div className={`lines ${variant === "dark" ? "on-dark" : ""} ${className}`} aria-hidden="true" />
);
